<template>
  <section class="about-screen-container"
           @animationend="showAnimation"
           v-animateonscroll="{ enterClass: 'fade-in'}">
    <div class="about-screen-content main-container">
      <div class="about-screen-info-container">
        <div class="left-container">
          <medium-title
              :font-family="$isMobile
              ? 'EurostileR'
              : 'Eurostile'">
            {{ mainTitle }}
          </medium-title>
          <div class="cards-container">
            <card-with-line v-for="(item, index) in cardInfo"
                                  :class="['animation-opacity', {'is-active-opacity' : isVisible(item.id)}]"
                                  :key="index"
                                  :item="item"/>
          </div>
        </div>

        <div class="cards-line-container">
          <card-about-num v-for="(item, index) in lineCardInfo"
                          :class="['animation-opacity', {'is-active-opacity' : isVisible(item.id)}]"
                          :key="index"
                          :item="item"/>
        </div>
      </div>

    </div>
    <div class="bg-container" :class="['animation-opacity', {'is-active-opacity' : isVisible(3)}]">
      <img :src="getUrl('about-bg-new.webp')" alt="main-bg">
    </div>
  </section>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import CardIconTitleInfo from "@/components/entities/cards/CardIconTitleInfo.vue";
import CardLineInfo from "@/components/entities/cards/CardLineInfo.vue";
import CardAboutNum from "@/components/entities/cards/CardAboutNum.vue";
import CardWithLine from "@/components/entities/cards/CardWithLine.vue";

export default {
  name: "AboutScreen",
  components: {CardWithLine, CardAboutNum, CardLineInfo, CardIconTitleInfo, MediumTitle},
  data() {
    return {
      visibleIndexItem: -1,
      lengthAnimation: 5,
      mainTitle: 'Преимущества \nкомпании',
      cardInfo: [
        {
          id: 0,
          title: 'Получен сертификат СТ1',
        },
        {
          id: 1,
          title: 'Ориентированность на заказчика',
        },
        {
          id: 2,
          title: 'Широкий спектр наличия оснастки на складе',
        },
        {
          id: 3,
          title: 'Единственный в России\nпроизводитель оснастки мирового уровня',
        },
        {
          id: 4,
          title: 'Конструкторский отдел по разработке\nспециально зажимной оснастки',
        },
      ],
      lineCardInfo: [
        {
          id: 0,
          title: '13',
          miniTitle: 'лет ',
          text: ' на рынке'
        },
        {
          id: 1,
          title: '150+',
          text: 'предприятий'
        },
        {
          id: 2,
          title: '50+',
          miniTitle: 'единиц',
          text: 'производственного\nоборудования'
        },
        {
          id: 3,
          title: '111+',
          text: 'сотрудников'
        },
        {
          id: 4,
          title: '7500+',
          miniTitle: 'м2',
          text: 'производственных площадей'
        },
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.about-screen-container {
  position: relative;
  width: 100%;
  background: var(--color-black-gradient);
  .text-content {
    white-space: pre-wrap;
  }
  .about-screen-content {
    justify-content: flex-end;
  }
  .about-screen-info-container {
    width: 100%;
    position: relative;
    z-index: 1;
    justify-content: space-between;
    display: flex;
    flex-direction: row;

    .left-container {
      display: flex;
      flex-direction: column;
    }

    .cards-container {
      display: flex;
      flex-direction: row;
      align-content: space-between;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .cards-line-container {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
    }

  }
  .bg-container {
    left: auto;
    right: 0;
  }
}

@media (max-width: 3024px){

  .about-screen-container {
    .about-screen-info-container {
      padding-top: 160px;
      padding-bottom: 160px;

      .left-container {
        max-width: 880px;
        row-gap: 154px;
      }
      .cards-container {
        column-gap: 40px;
      }

      .cards-line-container {
        max-width: 730px;
        column-gap: 48px;
      }
    }

    .bg-container {
      right: -10%;
    }
  }
}


@media (max-width: 1920px) {
  .about-screen-container {
    .about-screen-info-container {
      padding-top: 120px;
      padding-bottom: 120px;
      .left-container {
        max-width: 680px;
        row-gap: 154px;
      }
      .cards-container {
        row-gap: 32px;
      }

      .cards-line-container {
        max-width: 680px;
        column-gap: 40px;
      }
    }
    .bg-container {
      right: -15%;
    }
  }
}
@media (max-width: 1600px) {

  .about-screen-container {
    .about-screen-info-container {
      padding-top: 100px;
      padding-bottom: 100px;
      .left-container {
        max-width: 480px;
        row-gap: 154px;
      }

      .cards-container {
        row-gap: 24px;
      }

      .cards-line-container {
        max-width: 480px;
      }
    }

    .bg-container {
      top: 50%;
      transform: translateY(-50%);
      max-height: 632px;
      right: -15%;
    }
  }
}
@media (max-height: 800px) {
  .about-screen-container {
    .about-screen-info-container {
      padding-top: 80px;
      padding-bottom: 80px;
      .left-container {
        max-width: 430px;
        row-gap: 154px;
      }

      .cards-container {
        row-gap: 16px;
      }

      .cards-line-container {
        max-width: 360px;
      }
    }

    .bg-container {
      right: -25%;
      max-height: 100%;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .about-screen-container {
    .about-screen-info-container {
      padding-top: 100px;
      padding-bottom: 100px;
      .left-container {
        max-width: 480px;
        row-gap: 154px;
      }

      .cards-container {
        row-gap: 24px;
      }

      .cards-line-container {
        max-width: 480px;
      }
    }

    .bg-container {
      top: 50%;
      transform: translateY(-50%);
      max-height: 632px;
      right: -15%;
    }
  }
}

@media (max-width: 1133px) {
  .about-screen-container {
    .about-screen-info-container {
      padding-top: 80px;
      padding-bottom: 80px;
      .left-container {
        max-width: 430px;
        row-gap: 154px;
      }

      .cards-container {
        row-gap: 16px;
      }

      .cards-line-container {
        max-width: 360px;
      }
    }

    .bg-container {
      right: -25%;
      max-height: 100%;
    }
  }
}
@media (max-width: 769px) {
  .about-screen-container {
    .about-screen-info-container {
      flex-direction: column;
      row-gap: 40px;
      padding-top: 48px;
      padding-bottom: 48px;
      .left-container {
        max-width: 430px;
        row-gap: 40px;
      }

      .cards-container {
        row-gap: 16px;
      }

      .cards-line-container {
        max-width: 360px;
        row-gap: 24px;
        column-gap: 24px;
      }
    }

    .bg-container {
      top: auto;
      transform: none;
      right: -90%;
      bottom: 48px;
      max-height: 421px;
    }
  }
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .about-screen-container {
    .about-screen-info-container {
      padding-top: 360px;
      padding-bottom: 360px;

      .left-container {
        max-width: 1360px;
        row-gap: 214px;
      }
      .cards-container {
        row-gap: 82px;
        column-gap: 110px;
      }

      .cards-line-container {
        max-width: 1363px;
        column-gap: 100px;
      }
    }

    .bg-container {
      right: -10%;
      max-height: 1813px;
    }
  }
}

</style>